import React, { useEffect, useState } from 'react';
const FullscreenOffIcon = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", stroke: "currentColor", "aria-hidden": "true", focusable: "false", ...props },
    React.createElement("polyline", { points: "2 8 8 8 8 2", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("polyline", { points: "16 2 16 8 22 8", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("polyline", { points: "2 16 8 16 8 22", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("polyline", { points: "16 22 16 16 22 16", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("line", { x1: 8, y1: 8, x2: 1, y2: 1, fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeMiterlimit: 10 }),
    React.createElement("line", { x1: 23, y1: 1, x2: 16, y2: 8, fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeMiterlimit: 10 }),
    React.createElement("line", { x1: 8, y1: 16, x2: 1, y2: 23, fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeMiterlimit: 10 }),
    React.createElement("line", { x1: 23, y1: 23, x2: 16, y2: 16, fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeMiterlimit: 10 })));
const FullscreenOnIcon = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", stroke: "currentColor", "aria-hidden": "true", focusable: "false", ...props },
    React.createElement("polyline", { points: "7 1 1 1 1 7", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("polyline", { points: "23 7 23 1 17 1", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("polyline", { points: "7 23 1 23 1 17", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("polyline", { points: "23 17 23 23 17 23", fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("line", { x1: 1, y1: 1, x2: 8, y2: 8, fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeMiterlimit: 10 }),
    React.createElement("line", { x1: 16, y1: 8, x2: 23, y2: 1, fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("line", { x1: 1, y1: 23, x2: 8, y2: 16, fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 }),
    React.createElement("line", { x1: 16, y1: 16, x2: 23, y2: 23, fill: "none", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10 })));
const FullScreenButton = ({ isFullscreen, setIsFullscreen, className, handlerFullScreen, handlerExitFullScreen, }) => {
    const [errorOpen, setErrorOpen] = useState(false);
    const enterFullscreen = () => {
        try {
            if (handlerFullScreen) {
                handlerFullScreen();
            }
        }
        catch (error) {
            const roomContainer = document.getElementById('room-container');
            if (roomContainer) {
                roomContainer.classList.add('hide-navigation');
            }
            setErrorOpen(true);
        }
    };
    const exitFullscreen = () => {
        try {
            if (errorOpen) {
                const roomContainer = document.getElementById('room-container');
                if (roomContainer) {
                    roomContainer.classList.remove('hide-navigation');
                }
                return;
            }
            if (handlerExitFullScreen) {
                handlerExitFullScreen();
            }
        }
        catch (error) {
            const roomContainer = document.getElementById('room-container');
            if (roomContainer) {
                roomContainer.classList.remove('hide-navigation');
            }
        }
    };
    const toggleFullscreen = () => {
        if (isFullscreen) {
            exitFullscreen();
        }
        else {
            enterFullscreen();
        }
        setIsFullscreen(!isFullscreen);
    };
    useEffect(() => {
        const handleFullscreenChange = () => {
            if (!document.fullscreenElement || !document.webkitFullscreenElement) {
                setIsFullscreen(false);
            }
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        };
    }, [errorOpen]);
    useEffect(() => {
        return () => {
            try {
                const roomContainer = document.getElementById('room-container');
                if (roomContainer && roomContainer.classList.contains('hide-navigation')) {
                    roomContainer.classList.remove('hide-navigation');
                }
                setIsFullscreen(false);
            }
            catch (err) { }
        };
    }, []);
    return (
    // <Button id="fullscreenBtn" className={className} onClick={toggleFullscreen} option={{
    // 	buttonBeforeIcon: {
    // 		show: true,
    // 		name: isFullscreen ? 'fullscreenOn' : 'fullscreenOff',
    // 		size: 25,
    // 		color: '#fff',
    // 		className: 'handlerIcon',
    // 	}
    // }} />
    React.createElement("button", { id: "fullscreenBtn", className: className, onClick: toggleFullscreen, "aria-label": isFullscreen ? 'Exit full screen' : 'Enter full screen' }, isFullscreen ? (React.createElement(FullscreenOffIcon, { className: "handlerIcon" })) : (React.createElement(FullscreenOnIcon, { className: "handlerIcon" }))));
};
export default FullScreenButton;
